export default function SignatureForm() {
  return (
    <table className="w-full border">
      <thead className="print:text-2xs font-bold">
        <tr>
          <td className="w-0 border-b border-l px-1 text-left text-gray-800">
            COL
          </td>
          <td className="border-b border-l px-1 text-left text-gray-800">
            SIGNATURE
          </td>
          <td className="w-0 border-b border-l px-2 text-left text-nowrap text-gray-800">
            DATE (YYYY-MM-DD)
          </td>
          <td className="w-0 border-b border-l px-1 text-left text-gray-800">
            COL
          </td>
          <td className="border-b border-l px-1 text-left text-gray-800">
            SIGNATURE
          </td>
          <td className="w-0 border-b border-l px-2 text-left text-nowrap text-gray-800">
            DATE (YYYY-MM-DD)
          </td>
        </tr>
      </thead>
      <tbody>
        {new Array(5).fill(undefined).map((_, index) => (
          <tr key={index}>
            <td className="w-0 border-b border-l px-1 text-center font-bold text-gray-800">
              {index + 1}
            </td>
            <td className="border-b border-l px-1 text-left text-gray-800"></td>
            <td className="border-b border-l px-1 text-left text-gray-800"></td>
            <td className="w-0 border-b border-l px-1 text-center font-bold text-gray-800">
              {index + 6}
            </td>
            <td className="border-b border-l px-1 text-left text-gray-800"></td>
            <td className="border-b border-l px-1 text-left text-gray-800"></td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
